import { BaseError } from '@belimo-retrofit-portal/logic';
import { SagaIterator } from 'redux-saga';
import { Transition } from 'src/modules/routing/types/Transition';
import { logError } from 'src/sagas/utils/logging';
import { call } from 'typed-redux-saga';

export function* errorTransitionLogging(transition: Transition, error: BaseError): SagaIterator<void> {
  yield* call(logError, 'ROUTER. Transition failed', { transition, error });
}
